export const TYPES_PARAM = 't';
export const CATEGORIES_PARAM = 'c';
export const MAX_AMOUNT_PARAM = 'max';
export const MIN_AMOUNT_PARAM = 'min';
export const PAGE_PARAM = 'page';
export const PRODUCTION_TIME_PARAM = 'time';
export const SEARCH_PARAM = 'search';
export const SORT_PARAM = 'sort';
export const DESIGN_STATUS_PARAM = 'design_status__in';
export const PRODUCTION_STATUS_PARAM = 'production_status';
export const PAYMENT_STATUS_PARAM = 'payment_status';
export const TAGS_PARAM = 'tag__in';
export const EXPORTABLE_PARAM = 'exportable';
export const OFFSET_PARAM = 'offset';
export const AUTOMOCKUPS_PARAM = 'automockups';
export const LOGO_PARAM = 'display_logo';
export const DOMAIN_PARAM = 'domain';
export const POD_PARAM = 'is_pod';

export function getPageParamValue(searchParams: URLSearchParams) {
  const value = searchParams.get(PAGE_PARAM);
  return value ? parseInt(value, 10) : 1;
}

export function getSearchParamValue(searchParams: URLSearchParams) {
  return searchParams.get(SEARCH_PARAM) ?? '';
}

export function getExportableParamValue(searchParams: URLSearchParams) {
  const param = searchParams.get(EXPORTABLE_PARAM);
  if (!param) return null;
  return param === 'true' ? 'yes' : 'no';
}
